<template>
  <a-modal :visible="open" title="问卷调查" @ok="handleSubmit" @cancel="emit('close')" style="top: 20%">
    <p class="title">
      嗨！您已经在YinoLink周5出海中已经学习了不少海外营销知识~下面请继续完善您的出海营销背景，以便于我们更好地为您服务：
    </p>
    <p>请问您是否有过海外投放经验？</p>
    <a-radio-group v-model:value="value1" :options="plainOptions1" />
    <div v-if="value1 === '已开户投放'">
      <p>您投放的海外平台为？</p>
      <a-checkbox-group v-model:value="value2" :options="plainOptions2" />
      <p>您投放的品类为？</p>
      <a-radio-group v-model:value="value3" :options="plainOptions3" />
    </div>
    <div v-if="value1 === '未开户投放'">
      <p>您是否有海外投放的需求？</p>
      <a-radio-group v-model:value="value4" :options="plainOptions4" />
      <div v-if="value4 === '有'">
        <p>您计划想投放的海外平台为？</p>
        <a-checkbox-group v-model:value="value5" :options="plainOptions2" />
        <p>您计划投放的品类为？</p>
        <a-radio-group v-model:value="value6" :options="plainOptions3" />
      </div>
    </div>
    <img src="@/assets/images/studyQuestionDialog1.png" v-if="value1 === '已开户投放'" style="width: 100%; margin-top: 10px" />
    <img src="@/assets/images/studyQuestionDialog2.png" v-if="value1 === '未开户投放'" style="width: 100%; margin-top: 10px" />
  </a-modal>
</template>

<script setup>
import { ref } from 'vue'
import { submitForm } from '@/request/api/question.js'
import { message } from 'ant-design-vue'

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['close'])

const value1 = ref(null)
const value2 = ref(null)
const value3 = ref(null)
const value4 = ref(null)
const value5 = ref(null)
const value6 = ref(null)
const plainOptions1 = ref(['已开户投放', '未开户投放'])
const plainOptions2 = ref(['Facebook', 'TikTok', 'Bing', 'Google', '其他'])
const plainOptions3 = ref(['电商', 'App', '游戏'])
const plainOptions4 = ref(['有', '暂时没有'])

const validator = () => {
  if (value1.value === '已开户投放') {
    if (!value2.value) {
      message.error('请选择您投放的海外平台')
      return false
    }
    if (!value3.value) {
      message.error('请选择您投放的品类')
      return false
    }
    return true
  }
  if (value1.value === '未开户投放') {
    if (!value4.value) {
      message.error('请选择您是否有海外投放的需求')
      return false
    }
    if (value4.value === '有') {
      if (!value5.value) {
        message.error('请选择您计划想投放的海外平台')
        return false
      }
      if (!value6.value) {
        message.error('请选择您计划投放的品类')
        return false
      }
      return true
    }
    return true
  }
  if (value1.value === null) {
    message.error('请选择您是否有过海外投放经验')
    return false
  }
  return true
}

const handleSubmit = () => {
  if (!validator()) return
  const form = {
    type: 2,
    delivery: value1.value,
    platform: value2.value ? value2.value.join(',') : null,
    category: value3.value,
    need: value4.value,
    overseas_platform: value5.value ? value5.value.join(',') : null,
    other_category: value6.value,
  }
  // 过滤form中为null的属性
  const data = Object.entries(form).reduce((acc, [key, value]) => {
    if (value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});
  submitForm(data).then((res) => {
    if (res.code === 200) {
      message.success(res.msg)
      emit('close')
    }
  })
}
</script>

<style scoped>
p {
  margin: 10px 0;
}

.title {
  color: #3a84ff;
  font-weight: 600;
}
</style>
